import {
  toWSDateString,
  WSCard,
  WSDataItem,
  WSList
} from "@wingspanhq/fe-component-library";
import {
  Batch,
  BatchSummary,
  PayableImportBatchConfiguration
} from "@wingspanhq/wingspan-api-sdk";

import { PAYABLE_ENTITY_LABEL } from "./constants";
import { selectorImportBatchDisplayStatus } from "../../selectors/selectorImportBatchDisplayStatus";
import { selectorImportBatchUploadedFilename } from "../../selectors/selectorImportBatchUploadedFilename";
import { selectorPayableImportBatchStatusLabel } from "../../selectors/selectorPayableImportBatchStatusLabel";

type Props = {
  batch: Batch;
  /** Resolved before the page renders, so the row counts are never unknown. */
  batchSummary: BatchSummary;
};

export const PayableBatchDetailsWidget: React.FC<Props> = ({
  batch,
  batchSummary
}) => {
  const configuration = batch._configuration as
    | PayableImportBatchConfiguration
    | undefined;
  const breakdown = batchSummary.breakdown;

  return (
    <WSCard header="Details" divider>
      <WSList gap="XL">
        <WSDataItem
          inline
          label="Original spreadsheet"
          value={
            selectorImportBatchUploadedFilename({
              batch,
              entityLabel: PAYABLE_ENTITY_LABEL
            }) || "--"
          }
        />
        <WSDataItem
          inline
          label="Imported to payables"
          value={selectorImportBatchDisplayStatus(batch.status)}
        />
        <WSDataItem
          inline
          label="Created"
          value={
            batch.events?.createdAt
              ? toWSDateString(batch.events.createdAt)
              : "--"
          }
        />
        {/* TODO(v3-gap): v3 `Batch` carries no creator — see PLA ticket for the
            missing `createdBy`/actor on batches. */}
        <WSDataItem inline label="Creator" value="--" />
        <WSDataItem
          inline
          label="Contractors impacted"
          value={
            breakdown && "payeesImpactedCount" in breakdown
              ? breakdown.payeesImpactedCount
              : "--"
          }
        />
        <WSDataItem
          inline
          label="Import strategy"
          value={configuration?.processingStrategy ?? "--"}
        />
        <WSDataItem
          inline
          label="Initial status of created payables"
          value={selectorPayableImportBatchStatusLabel(configuration)}
        />
      </WSList>
    </WSCard>
  );
};
